import { render } from "./MembershipPoint.vue?vue&type=template&id=a4ab9bd0&scoped=true"
import script from "./MembershipPoint.vue?vue&type=script&lang=js"
export * from "./MembershipPoint.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=a4ab9bd0&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=1&id=a4ab9bd0&scoped=true&lang=css"
import "@/assets/css/user/pages/payment.css?vue&type=style&index=2&id=a4ab9bd0&scoped=true&lang=css"
import "@/assets/css/user/pages/keypad.css?vue&type=style&index=3&id=a4ab9bd0&scoped=true&lang=css"
import "./MembershipPoint.vue?vue&type=style&index=4&id=a4ab9bd0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4ab9bd0"]])

export default __exports__